import React from 'react';
import {
  Avatar,
  Dropdown,
  Menu,
  Typography,
  Space,
  Tooltip,
  MenuProps,
  theme,
} from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  InfoCircleOutlined,
  DownOutlined,
} from '@ant-design/icons';
import styles from './SidebarProfile.module.scss';
import { useAppDispatch, useAppSelector } from '@/hooks/hooks';
import { useNavigate } from 'react-router-dom';
import { clearAuthToken } from '@/store/slices/auth/authSlice';
import { useTheme } from '@/contexts/themeContext';

const { useToken } = theme;

const iconStyle = { fontSize: '16px' };
const items: MenuProps['items'] = [
  {
    key: '1',
    label: 'Profile',
    icon: <SettingOutlined style={iconStyle} />,
  },
  {
    key: '2',
    icon: <LogoutOutlined style={iconStyle} />,
    label: 'Log Out',
  },
];

const UserProfileDropdown = () => {
  const { sidebarCollapseState } = useTheme();
  const { userData } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { token } = useToken();

  const items: MenuProps['items'] = [
    {
      key: 'email',
      label: (
        <div
          style={{
            cursor: 'default',
            color: token.colorText,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            borderBottom: '1px solid #e0e0e0',
            padding: '8px 0px',
          }}
        >
          <Avatar>
            {userData?.name
              ? userData?.name?.charAt(0).toUpperCase()
              : userData?.email?.charAt(0).toUpperCase()}
          </Avatar>
          <span
            style={{
              fontWeight: '500',
            }}
          >
            {userData?.email}
          </span>
        </div>
      ),
    },
    {
      key: '1',
      label: 'Profile',
      icon: <UserOutlined style={iconStyle} />,
    },
    {
      key: '2',
      icon: <LogoutOutlined style={iconStyle} />,
      label: 'Log Out',
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '2') {
      dispatch(clearAuthToken());
      navigate('/auth');
    }
    if (e.key === '1') {
      navigate('/profile');
    }
  };

  return (
    <Dropdown
      menu={{ items, onClick: handleMenuClick }}
      trigger={['click']}
      placement="bottomRight"
    >
      {/* <Tooltip title={userData?.email}> */}
      <Space className={styles.trigger} style={{ cursor: 'pointer' }}>
        {sidebarCollapseState ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Avatar
              size="large"
              style={{
                backgroundColor: '#003862',
              }}
            >
              {userData?.name
                ? userData?.name?.charAt(0).toUpperCase()
                : userData?.email?.charAt(0).toUpperCase()}
            </Avatar>
          </div>
        ) : (
          <>
            <Avatar
              style={{
                backgroundColor: '#003862',
              }}
            >
              {userData?.name
                ? userData?.name?.charAt(0).toUpperCase()
                : userData?.email?.charAt(0).toUpperCase()}
            </Avatar>

            <div className={styles.details}>
              <Typography.Text
                type="secondary"
                ellipsis
                className={styles.email}
              >
                {userData?.email}
              </Typography.Text>
            </div>

            <DownOutlined
              style={{
                color: '#fff',
                fontSize: '12px',
              }}
            />
          </>
        )}
      </Space>
      {/* </Tooltip> */}
    </Dropdown>
  );
};

export default UserProfileDropdown;
